/*
  Tokyo Romance Club — SHOP BY PRICE scroll reveal + CTA arrow isolation.
  Each of the 4 price-band cards is observed independently via
  IntersectionObserver, so items only fade up once they individually
  enter the viewport. Cards that become visible together (e.g. all 4 on
  a tall viewport, or a 2x2 row on mobile) stagger by ~95ms. Once
  revealed, a card is unobserved and never re-hidden. Never runs inside
  the theme editor.

  Also wraps the trailing "→" of each "EXPLORE →" CTA label in its own
  span so trc-shop-by-price-motion.css can nudge only the arrow on hover,
  independent of the label text. The label text itself (from
  templates/index.json) is untouched — this only re-parents the last
  character into a span.
*/
(function () {
  if (window.__trcShopByPriceMotionInit) return;
  window.__trcShopByPriceMotionInit = true;

  var designMode = document.documentElement.classList.contains('shopify-design-mode');
  if (designMode) return;

  var reduceMotion = false;
  try {
    reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  var REVEAL_CLASS = 'trc-sbp-in';
  var STAGGER_MS = 95;

  function reveal(el) {
    el.classList.add(REVEAL_CLASS);
  }

  function wrapCtaArrows(section) {
    var ctas = section.querySelectorAll('[class*="__button_cta"]');
    for (var i = 0; i < ctas.length; i++) {
      var cta = ctas[i];
      if (cta.querySelector('.trc-cta-arrow')) continue;
      var match = /^(.*?)(\s*)(→)\s*$/.exec(cta.textContent);
      if (!match) continue;
      cta.textContent = '';
      cta.appendChild(document.createTextNode(match[1] + match[2]));
      var arrow = document.createElement('span');
      arrow.className = 'trc-cta-arrow';
      arrow.textContent = match[3];
      cta.appendChild(arrow);
    }
  }

  function init() {
    var section = document.querySelector('[id$="__trc_shop_by_price"]');
    if (!section) return;

    document.documentElement.classList.add('trc-js');

    wrapCtaArrows(section);

    var targets = Array.prototype.slice.call(section.querySelectorAll('.group-block'));
    if (targets.length === 0) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries
          .filter(function (entry) {
            return entry.isIntersecting;
          })
          .forEach(function (entry, i) {
            io.unobserve(entry.target);
            window.setTimeout(function () {
              reveal(entry.target);
            }, i * STAGGER_MS);
          });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
    );

    targets.forEach(function (target) {
      io.observe(target);
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
